import _slicedToArray from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback as $bnPw9$useCallback, useState as $bnPw9$useState, useRef as $bnPw9$useRef, useEffect as $bnPw9$useEffect } from "react";
import { useCallbackRef as $bnPw9$useCallbackRef } from "@radix-ui/react-use-callback-ref";

function $71cd76cc60e0454e$export$6f32135080cb4c3(_ref) {
  var prop = _ref.prop,
      defaultProp = _ref.defaultProp,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange;

  var _$71cd76cc60e0454e$va = $71cd76cc60e0454e$var$useUncontrolledState({
    defaultProp: defaultProp,
    onChange: onChange
  }),
      _$71cd76cc60e0454e$va2 = _slicedToArray(_$71cd76cc60e0454e$va, 2),
      uncontrolledProp = _$71cd76cc60e0454e$va2[0],
      setUncontrolledProp = _$71cd76cc60e0454e$va2[1];

  var isControlled = prop !== undefined;
  var value1 = isControlled ? prop : uncontrolledProp;
  var handleChange = $bnPw9$useCallbackRef(onChange);
  var setValue = $bnPw9$useCallback(function (nextValue) {
    if (isControlled) {
      var setter = nextValue;
      var value = typeof nextValue === 'function' ? setter(prop) : nextValue;
      if (value !== prop) handleChange(value);
    } else setUncontrolledProp(nextValue);
  }, [isControlled, prop, setUncontrolledProp, handleChange]);
  return [value1, setValue];
}

function $71cd76cc60e0454e$var$useUncontrolledState(_ref2) {
  var defaultProp = _ref2.defaultProp,
      onChange = _ref2.onChange;
  var uncontrolledState = $bnPw9$useState(defaultProp);

  var _uncontrolledState = _slicedToArray(uncontrolledState, 1),
      value = _uncontrolledState[0];

  var prevValueRef = $bnPw9$useRef(value);
  var handleChange = $bnPw9$useCallbackRef(onChange);
  $bnPw9$useEffect(function () {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef, handleChange]);
  return uncontrolledState;
}

export { $71cd76cc60e0454e$export$6f32135080cb4c3 as useControllableState };